import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useAddMembersToGroups() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({ userUuids, groupUuids }: { userUuids: string[]; groupUuids: string[] }) => {
      await api.post('group/assign-members-to-groups', {
        members: userUuids,
        groups: groupUuids,
      })

      await Promise.all([invalidate.users(), invalidate.groups()])
    },
  })
}
